import { tracker } from '@openreplay/tracker'
import { AuthController } from '@platform/modules/identity/client/AuthController'

/**
 * Инициализация OpenReplay с автоматической привязкой пользователя.
 * Подписывается на изменения AuthController и передаёт данные пользователя в tracker.
 */
function initOpenReplay() {
    // TODO: тестируем openreplay, если ок перенесем в .env
    const projectKey = import.meta.env.VITE_OPEN_REPLAY_KEY as string;
    const sessionTokenHeader = import.meta.env.VITE_OPEN_REPLAY_SESSION_NAME as string;

    if (!projectKey) return;

    tracker.configure({
      projectKey,
      capturePerformance: true, 
      network: {
        useProxy: false,
        failuresOnly: false,
        // ignoreHeaders: Array<string> | boolean;
        capturePayload: true,
        sessionTokenHeader,
        ignoreHeaders: false,
        captureInIframes: false
      }  
    });

    tracker.start()

    // Подписываемся на изменения пользователя в AuthController
    const authController = AuthController.getInstance();
    authController.subscribe(() => {
      const state = authController.getSnapshot();
      
      if (state.isAuthenticated && state.user) {
        // Передаём email или name пользователя в OpenReplay
        const userIdentifier = state.user.email || state.user.name || `user_${state.user.id}`;
        tracker.setUserID(userIdentifier);
        
        // Опционально: можем передать дополнительные метаданные
        tracker.setMetadata('user_name', state.user.name || '');
        tracker.setMetadata('user_roles', state.user.roles?.join(',') || '');
      } else {
        // Очищаем данные при logout
        tracker.setUserID('');
      }
    });
}

export { initOpenReplay }